const {
  ENGLISH,
  GERMAN,
  FRENCH,
  SPANISH,
} = require('../config');

module.exports = {
  [ENGLISH]: {
    format: '%u%n',
    sign_first: true,
    separator: '.',
    delimiter: ',',
    precision: 2,
  },
  [GERMAN]: {
    format: '%n\u00A0%u',
    sign_first: true,
    separator: ',',
    delimiter: '.',
    precision: 2,
  },
  [FRENCH]: {
    format: '%n\u00A0%u',
    sign_first: true,
    separator: ',',
    delimiter: '\u00A0',
    precision: 2,
  },
  [SPANISH]: {
    format: '%n\u00A0%u',
    sign_first: true,
    separator: ',',
    delimiter: '.',
    precision: 2,
  },
};
